/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestServiceProvider } from '../../RestServiceProvider';
import { ActionRequestServiceLevelService } from './ActionRequestServiceLevelService';

class ActionRequestServiceLevelServiceProvider extends RestServiceProvider {
    getServiceInstance($q, resource, $httpParamSerialiserJQLike, $log) {
        return new ActionRequestServiceLevelService($q, resource, $httpParamSerialiserJQLike, $log);
    }
}

export { ActionRequestServiceLevelServiceProvider };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/actionrequest/service/ActionRequestServiceLevelServiceProvider.js